import { memo, useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { OpoRoleEnum } from '@/api/apis/customer';
import { CreateOpoContactFormValues } from '../types';
import { OpoRoleSelector } from './OpoRoleSelector';

type Props = {
  index: number;
  orgName: string;
  isReadOnly?: boolean;
  isRequired?: boolean;
};

export const OpoMembershipRoleForm = memo(({ index, orgName, isReadOnly = false, isRequired = false }: Props) => {
  const { control, setValue } = useFormContext<CreateOpoContactFormValues>();

  const roleValues = useWatch({
    control,
    name: `memberships.${index}.roles`,
  }) as OpoRoleEnum[] | undefined;

  const handleRoleChange = useCallback(
    (roles: string[]) => {
      setValue(`memberships.${index}.roles`, roles as OpoRoleEnum[], {
        shouldValidate: true,
        shouldDirty: true,
      });
    },
    [index, setValue],
  );

  return (
    <div className="flex flex-col gap-2">
      <span className="text-hs text-base-5 m-0">{orgName || 'OPO Organization'}</span>

      <OpoRoleSelector
        name={`memberships.${index}.roles`}
        roleValues={roleValues ?? []}
        onChange={handleRoleChange}
        isReadOnly={isReadOnly}
        isRequired={isRequired}
      />
    </div>
  );
});

OpoMembershipRoleForm.displayName = 'OpoMembershipRoleForm';
